var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"uikit_list_item",class:{ selected: _vm.selected, light: _vm.light },on:{"click":_vm.callback}},[(_vm.icon)?_c('uikit-icon',{attrs:{"name":_vm.icon}}):_vm._e(),_c('h5',[_vm._v(_vm._s(_vm.name))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }